import React, { useState, useEffect, useRef } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import GeorgesAssistant from '../Georges/GeorgesAssistant';
import AlertesBanner from '../Alertes/AlertesBanner';
import { useAuth } from '../../context/AuthContext';
import { showsOutils } from '../../utils/permissions';

export default function Layout() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const mainRef = useRef(null);
  const { user } = useAuth();
  // Comptes à périmètre réduit (salarié, tablette de crèche) : pas d'outils transverses.
  const outils = showsOutils(user?.role);

  // Ferme le menu mobile + REMONTE EN HAUT de la page à chaque changement de page
  useEffect(() => {
    setMenuOpen(false);
    try { mainRef.current?.scrollTo({ top: 0, left: 0 }); } catch { if (mainRef.current) mainRef.current.scrollTop = 0; }
    try { window.scrollTo(0, 0); } catch { /* noop */ }
  }, [location.pathname]);

  return (
    <div className="flex h-screen overflow-hidden bg-cream-200">
      <Sidebar open={menuOpen} onClose={() => setMenuOpen(false)} />
      {/* Voile sombre derrière le tiroir (mobile) */}
      {menuOpen && (
        <div className="fixed inset-0 bg-navy-900/40 z-30 md:hidden" onClick={() => setMenuOpen(false)} />
      )}
      <div className="flex-1 flex flex-col min-w-0">
        <Header onMenu={() => setMenuOpen(true)} />
        <main ref={mainRef} className="flex-1 p-4 sm:p-6 overflow-auto animate-fade-in">
          <Outlet />
        </main>
      </div>
      {/* Alertes réglementaires */}
      {outils && <AlertesBanner />}
      {/* Georges - Majordome assistant flottant */}
      {outils && <GeorgesAssistant />}
    </div>
  );
}
